import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject } from "aurelia-framework";
import { MepVesselStatisticItemViewModel } from "../../tabs/mep-dashboard/partials/mep-vessel-statistics/mep-vessel-statistics";
import {CustomerDetailsModel} from "../../../../../../models/customers/customer.models";

@autoinject
export class VesselTypeDistributionDialog {
    model: MepVesselStatisticItemViewModel;
    customerDetails: CustomerDetailsModel;
    
    constructor(private dialogClientService: DialogClientService) { }


    activate(model: MepVesselStatisticItemViewModel){
        this.model = model;
        this.customerDetails = CustomerDetailsModel.getCustomerDetailModelFromRSUser(window["rightshipUser"]);
    }

    cancel() {
        this.dialogClientService.hide();
    }
}